import { getWrapperNativeTokenAddress } from './contracts';
import { getChainById } from './viem-chain-map';
export function getWrapperNativeToken(chainId) {
    const chain = getChainById(chainId);
    return {
        chainId,
        symbol: `W${chain.nativeCurrency.symbol}`,
        name: `W${chain.nativeCurrency.symbol}`,
        decimals: chain.nativeCurrency.decimals,
        address: getWrapperNativeTokenAddress(chainId),
        isInternalWrapToken: true,
    };
}
export function getSymbolFromWrapToken(token) {
    if (token.isInternalWrapToken) {
        return token.symbol.slice(1);
    }
    return token.symbol;
}
//# sourceMappingURL=wrapper-native-token.js.map